import React from 'react'
import PlutoUser from './PlutoUser'
import { IoCloseSharp } from 'react-icons/io5'

function PlutoUserModal({ userID }) {
    return (
        <div
            className='modal'
            style={{
                display: 'flex',
                position: 'fixed',
                inset: 0,
                background: 'rgba(0,0,0,0.7)',
                zIndex: 50,
                alignItems: 'center',
                justifyContent: 'center'
            }}
            onClick={(e) => {
                if (e.target.classList.contains('modal') && !e.target.classList.contains('modal-body')) {
                    e.target.style.display = 'none'
                }
            }}
        >
            <div
                className='withdraw-msg-modal modal-body'
                style={{
                    width: '90vw',
                    maxHeight: '90vh',
                    overflowY: 'auto',
                    background: '#161b22',
                    border: '1px solid #30363d',
                    borderRadius: '12px',
                    position: 'relative'
                }}
            >
                <IoCloseSharp
                    className='modal-close'
                    style={{
                        position: 'absolute',
                        top: '12px',
                        right: '12px',
                        cursor: 'pointer',
                        color: '#8b949e',
                        fontSize: '24px',
                        zIndex: 10,
                        transition: 'color 0.2s'
                    }}
                    onMouseEnter={(e) => e.target.style.color = '#e6edf3'}
                    onMouseLeave={(e) => e.target.style.color = '#8b949e'}
                    onClick={(e) => {
                        if (e.target.parentNode.parentNode.classList.contains('modal') && !e.target.parentNode.parentNode.classList.contains('modal-body')) {
                            e.target.parentNode.parentNode.style.display = 'none'
                        }
                    }}
                />
                <PlutoUser second_page={userID} x={1} />
            </div>
        </div>
    )
}

export default PlutoUserModal
